import { createFileRoute } from '@tanstack/react-router'
import { BillingPaymentsPage } from '@/features/billing/billing-payments-page'

export const Route = createFileRoute('/settings/payments')({
  component: BillingPaymentsPage,
})
